module.exports = __webpack_public_path__ + "static/media/billboard-pt-cards.3bcba350.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/billboard-pt-cards.png
 ** module id = 436
 ** module chunks = 0
 **/